<div class="container-fluid h-100 d-flex flex-column login-page">
    <div class="row justify-content-center px-4">
        <form class="login-form d-flex align-items-center justify-content-center" (ngSubmit)="login(loginForm)" [formGroup]="loginForm" novalidate>
            <mat-card class="col-12 col-md-6 col-lg-4 col-xl-3 p-3">
                <mat-card-content class="d-flex flex-column">
                    <h2 class="mb-2 mt-2 text-center red-400">{{ 'auth.connection' | translate }}</h2>
                    <span class="ml-2 mb-2">{{ 'auth.login' | translate }}</span>
                    <mat-form-field class="mb-2" appearance="fill">
                        <input matInput type="email" formControlName="email" placeholder="Email" required />

                    </mat-form-field>
                    <span class="ml-2 mb-2">{{ 'auth.password' | translate }}</span>
                    <mat-form-field class="mb-2" appearance="fill">
                        <input matInput type="password" formControlName="password" placeholder="Password" required />

                    </mat-form-field>
                    <div class='text-center'>
                        <button mat-raised-button class="align-self-start text-center px-3 py-1" color="primary" [disabled]="!loginForm.valid">
                            {{ 'auth.connect' | translate }}
                        </button>
                    </div>
                    <br />
                    <p class="forgotten-password align-self-start d-flex align-items-center pointer" (click)="showResetPasswordLinkDialog()">
                        <mat-icon class='red-400'>arrow_right</mat-icon>
                        <span>{{ 'auth.forgotten_password' | translate }}</span>
                    </p>
                    <ng-container *ngIf="(getOAuth2Providers() | async).length">
                        <hr class="mb-2 mt-3" />
                        <button mat-raised-button color="primary" *ngFor="let provider of getOAuth2Providers() | async" (click)="loginWithOAuth2(provider.url)" class="d-flex align-items-center justify-content-center ff-link">
                            <mat-icon>arrow_right</mat-icon>
                            Connect via {{provider.label}}
                        </button>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </form>
    </div>
</div>